import { nanoid } from 'nanoid'

export type GeneratedId = string & { _none: '' }

export function generateId(id?: string): GeneratedId {
  if (id) return id as GeneratedId
  return nanoid() as GeneratedId
}
